"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Navigation_1 = require("../Navigation/Navigation");
var Translation_1 = require("../Translation/Translation");
var altMainHeaderStyles_1 = require("./altMainHeaderStyles");
var AltMainHeader = function () {
    var styles = altMainHeaderStyles_1.default();
    return (<core_1.Box className={styles.navigationContainer}>
      <Navigation_1.default withIcon={false} backTextClassName={styles.backText} backTextVariant={'body2'}/>
      <core_1.Typography variant="h1" className={styles.mainHeaderText}>
        <Translation_1.default id="checkout.journeyType.continueDealership" defaultMessage="share your customised lexus with us"/>
      </core_1.Typography>
      <core_1.Typography variant="body2" className={styles.subHeaderText}>
        <Translation_1.default id="checkout.journeyType.checkoutReserveOnline" defaultMessage="Your selected dealer will contact you about your configured vehicle and get you into your dream Lexus soon."/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = AltMainHeader;
